export const EMAIL_REGEX = new RegExp('[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+');
export const ZIP_REGEX = /^((\d{4}-\d{4}|\d{4}){1}(,{1}\s*(\d{4}-\d{4}|\d{4}){1})*)+$/;
export const EMPTY_REGEX = new RegExp(''); // TODO: Empty to avoid linting issue. Remove when more than one regex exists.
